import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select"];

  selectCategory(event) {
    const categoryType = event.params.kind;

    // Scroll to registration section
    const registrationSection = document.getElementById("registration");
    if (registrationSection) {
      registrationSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    // Wait for scroll to complete
    setTimeout(() => {
      if (this.hasSelectTarget) {
        this.selectTarget.value = categoryType;

        // Add visual effect
        this.selectTarget.classList.add(
          "ring-4",
          "ring-teal-200",
          "border-teal-500",
        );
        setTimeout(() => {
          this.selectTarget.classList.remove("ring-4", "ring-teal-200");
        }, 2000);
      }
    }, 500);
  }
}
